import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getClerksURL, getPersonnelsURL } from '../utils/api';

const useGetPersonnels = ({ 
        page = 1,
        limit = 3000,
        keyword,
        setErrors,
        isToolsClerk = false
    }) => {
        
    const { auth } = useAuth();
    const [ gettingPersonnels, setGettingPersonnels ] = useState(false);
    const [ personnels, setPersonnels ] = useState([]);
    const [ totalPersonnels, setTotalPersonnels ] = useState(0);
    const [ gettingPersonnelsReqSuccess, setGettingPersonnelsReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingPersonnels) {
            axios.get(
                !isToolsClerk 
                    ? getPersonnelsURL
                    : getClerksURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword,
                }
            }).then(result => {
                setGettingPersonnels(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalPersonnels(result.data.total);
                    }
                    setGettingPersonnelsReqSuccess(true);
                    setPersonnels(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingPersonnelsReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingPersonnelsReqSuccess(false);
                setGettingPersonnels(false);
            });
        }
    }, [gettingPersonnels]);

    return { personnels, totalPersonnels, gettingPersonnels, setGettingPersonnels, gettingPersonnelsReqSuccess };
}

export default useGetPersonnels;